import { Form } from 'formik';
import { Breakpoints } from 'kinedu-react-components';
import styled from 'styled-components';

const StyledAuthView = styled.div.attrs(() => ({
  className: 'AuthWrapper',
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Title = styled.span.attrs(() => ({
  className: 'AuthTitle',
}))`
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 0;
  margin: 10px 0 0;
  line-height: 30px;
  ${({ theme }) => `
    color: ${theme.colors.blue};
    ${theme.breakPoints.tablet} {
      font-size: 2.4rem;
    }
  `};
`;

const Subtitle = styled.span.attrs(() => ({
  className: 'AuthSubtitle',
}))`
  font-size: 1.6rem;
  ${({ theme }) => `
    ${theme.breakPoints.tablet} {
      font-size: 2rem;
    }
  `}
  color: #333333;
  font-weight: 300;
  margin-bottom: 30px;
`;

const Footer = styled.div.attrs(() => ({
  className: 'AuthFooter',
}))`
  margin: 10px 0 0;

  button {
    font-size: 12px;
    padding: 0 0 0 5px;
    ${Breakpoints.largePhone} {
      font-size: 16px;
    }
  }
`;

const Note = styled.span.attrs(() => ({
  className: 'AuthNote',
}))`
  color: #657480;
  font-weight: 100;
  margin-top: 20px;
  font-size: 13px;
  ${Breakpoints.largePhone} {
    font-size: 16px;
  }
`;

const ForgotPasswordLink = styled.p.attrs(() => ({
  className: 'AuthForgotPasswordLink',
}))`
  ${({ theme }) => `
    color: ${theme.colors.blue};
  `};
  font-size: 1.4rem;
  font-weight: bold;
  text-align: right;
  letter-spacing: 0;
  cursor: pointer;
  margin: 10px 0;
  text-decoration: underline;
`;

const ErrorMessage = styled.p.attrs(() => ({
  className: 'AuthErrorMessage',
}))`
  color: #ff0039;
  font-size: 12px;
  font-weight: 300;
  padding: 0px 0px;
  margin: 0;
  text-transform: initial;
  text-align: right;
  ${({ children }) =>
    !children
      ? ''
      : `
    position: relative;
    top: -6px;
  `}

  &::first-letter {
    text-transform: uppercase;
  }
`;

const SignUpText = styled.p.attrs(() => ({
  className: 'SignUpText',
}))`
  font-weight: 300;
  color: #333;
  font-size: 1.4rem;
  text-align: center;
  span {
    font-weight: 600;
    background-color: transparent;
    outline: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 5px;
    ${({ theme }) => `
      color: ${theme?.colors?.primary};
    `}
    text-decoration: underline;
  }
`;

const SignInText = styled.p.attrs(() => ({
  className: 'SignInText',
}))`
  font-weight: 300;
  color: #333;
  font-size: 1.4rem;
  text-align: center;
  span {
    font-weight: 600;
    background-color: transparent;
    outline: none;
    border: none;
    text-decoration: underline;
    cursor: pointer;
    margin-left: 5px;
    ${({ theme }) => `
      color: ${theme?.colors?.blue};
    `}
  }
`;

const SubmitButtonContainer = styled.div.attrs(() => ({
  className: 'AuthSubmitButtonContainer',
}))`
  margin: 2rem 0;
  button {
    max-width: 290px;
    margin: 0 auto;
  }
`;

const FormContent = styled(Form).attrs(() => ({
  className: 'AuthForm',
}))`
  width: 100%;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: center;
  & > .texter {
    margin: 0 0 1rem;
  }
`;

export const ContentForm32 = styled.div.attrs(() => ({
  className: 'ContentForm',
}))`
  color: ${({ theme }) => theme.colors.darkGray};
  font-weight: bold;

  display: flex;
  flex-direction: column;
  justify-content: center;

  & p {
    padding: 0;
    margin: 0;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    margin-bottom: 10px;
  }
`;

export default StyledAuthView;
export {
  Title,
  Subtitle,
  Footer,
  Note,
  ForgotPasswordLink,
  ErrorMessage,
  SignUpText,
  SignInText,
  SubmitButtonContainer,
  FormContent,

};
